<template>
  <div>
    <v-card color="#EDF1F3" v-if="this.plan">
      <v-layout align-center justify-start style="padding-inline-start: 20px">
        <v-flex xs3>
          <div class="headline">{{ $t("planningPage.startDate") }}: {{ this.plan.start_date }}</div>
          <div class="headline">{{ $t("planningPage.endDate") }}: {{ this.plan.end_date }}</div>
          <div style="color: #8599a3">{{ $t("planningPage.shiftsCount") }}: {{ this.shifts.length }}</div>
        </v-flex>
      </v-layout>
    </v-card>
    <v-card>
      <v-card-title>
        <v-layout>
          <v-flex xs6 style="padding: 8px">
            <!-- <choose-date
              clearable
              label="Filter by day"
              v-model="date_filter"
            ></choose-date> -->
            <v-select
              :label="$t('planningPage.planType')"
              :items="['SEASONAL', 'NORMAL']"
              :rules="[required]"
              v-model="plan_type"
              @change="getPlanShifts"
            />
          </v-flex>
          <!-- <v-flex xs6 style="padding: 8px">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Username"
                single-line
                hide-details
                @keyup.enter="getData"
              ></v-text-field>
            </v-flex> -->
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="shifts"
        :pagination.sync="pagination"
        :total-items="totalItems"
        :rows-per-page-items="[5, 10, 15, 25, 100]"
        :loading="loading"
        :actions-extra-main="actionsExtraMain"
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">
              <span>{{ props.item.id }}</span>
            </td>
            <td class="text-xs-center">
              <span>{{ props.item.day }}</span>
            </td>
            <td class="text-xs-center">
              <span>{{ props.item.from }}</span>
            </td>
            <td class="text-xs-center">
              <span>{{ props.item.to }}</span>
            </td>
            <td class="text-xs-center">
              <span>{{ props.item.current_drivers }}</span>
            </td>
            <td class="text-xs-center">
              <span>{{ props.item.expected_drivers }}</span>
            </td>
            <td class="text-xs-center" v-if="permission != 'Goverment'">
              <span v-if="props.item.expected_drivers">
                <v-icon @click="editShift(props.item)">edit</v-icon>
              </span>
            </td>
            <!-- <td class="text-xs-center">
              <span>
                <v-icon
                  @click="
                    $router.push({
                      path: `/shift_map/${props.item.booking_id}`,
                    })
                  "
                  >info</v-icon
                >
              </span>
            </td> -->
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
  
  <style>
.hbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}
</style>
  
  <script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import { companyToday, formatCompanyTime } from "@/util/companyTime";
import ChooseDate from "@/components/monaco/input/ChooseDate";

const required = (val) =>
  (val !== null && val !== undefined) || "this field is required";
const email = (val) =>
  (!!val && val.search(/^(\w|-|\.|_)+@(\w|-|\.|_)+\.\w+$/) !== -1) ||
  "this must be a valid email";
const past = (val) =>
  (!!val && moment(val).format("YYYY-MM-DD") < companyToday()) ||
  "this must be past date";

export default {
  name: "Shifts",
  title() {
    return this.$t("planningPage.shiftsTitle");
  },
  components: { DataTable, ChooseDate },
  data() {
    return {
      permission: null,
      plan_type: "NORMAL",
      shifts: [],
      plan: null,
      loading: false,
      date_filter: null,
      totalItems: 0,
      pagination: {
        sortBy: "id",
        rowsPerPage: 100,
      },
      formatters: {
        created_at(value) {
          return formatCompanyTime(value, " DD MMM YYYY");
        },
      },
    };
  },

  computed: {
    headers() {
      const cols = [
        { text: this.$t("planningPage.id"), value: "id", sortable: false, align: "center" },
        { text: this.$t("planningPage.day"), value: "day", sortable: false, align: "center" },
        { text: this.$t("planningPage.from"), value: "from", sortable: false, align: "center" },
        { text: this.$t("planningPage.to"), value: "to", sortable: false, align: "center" },
        { text: this.$t("planningPage.currentDrivers"), value: "current_drivers", sortable: false, align: "center" },
        { text: this.$t("planningPage.expectedDrivers"), value: "expected_drivers", sortable: false, align: "center" },
      ];
      if (this.permission != "Goverment") {
        cols.push({ text: this.$t("planningPage.edit"), value: "edit", sortable: false, align: "center" });
      }
      return cols;
    },
    titles() {
      return {
        id: this.$t("planningPage.id"),
        name: this.$t("planningPage.eventName"),
        start_date: this.$t("planningPage.startDate"),
        end_date: this.$t("planningPage.endDate"),
        last_appliance_date: this.$t("planningPage.lastApplianceDateCol"),
        registered_drivers: this.$t("planningPage.registeredDrivers"),
        created_at: this.$t("planningPage.creationDate"),
      };
    },
    actionsExtraMain() {
      return {
        info: {
          title: this.$t("planningPage.info"),
          icon: "info",
          action: (item) =>
            this.$router.push({
              name: "EventDetails",
              params: { id: item.id },
            }),
        },
      };
    },
  },
  mounted() {
    this.permission = this.$store.state.user.roles[0].name;
    this.getPlanShifts();
  },
  methods: {
    getPlanShifts() {
      this.shifts = [];
      this.plan = null;
      this.loading = true;
      const params = new URLSearchParams();
      // params.append("page", this.pagination.page);
      // params.append("perPage", String(this.pagination.rowsPerPage));
      // params.append("sortBy", "id");
      params.append("plan_type", this.plan_type);
      // if (this.date_filter) {
      //   params.append("date", this.date_filter);
      // }
      this.axios
        .get("shifts/schedule_plan", { params })
        .then((res) => {
          this.plan = res.data.data;
          this.shifts = res.data.data.shifts;
          // console.log("data");
          // console.log(this.plan);
          this.loading = false;
        })
        .catch((err) => {
          // console.log("err");
          // console.log(err.response.data.message);
          this.loading = false;
          var message = err.response.data.message;
          window.getApp.$emit("SHOW_TOAST", message, "red");
        });
    },
    editShift(shift) {
      var shift_id = shift.id;
      this.$dialova({
        title: this.$t("planningPage.editShiftTitle", { id: shift_id }),
        paragraph: this.$t("planningPage.editShiftParagraph"),
        loader: true,
        input: this.$t("planningPage.editShiftInput"),
        type: "number",
        inputValue: shift.expected_drivers,
      })
        .then(({ close, value }) => {
          var expected_drivers = value;
          this.axios
            .put(`shifts/${shift_id}/shift_expected_drivers`, {
              expected_drivers: expected_drivers,
            })
            .then((res) => {
              var message = res.data.message;
              window.getApp.$emit("SHOW_TOAST", message, "green");
              const index = this.shifts.findIndex((object) => {
                return object.id === shift_id;
              });
              if (index !== -1) {
                this.shifts[index].expected_drivers = expected_drivers;
              }
              close();
            })
            .catch((err) => {
              var message = err.response.data.message;
              window.getApp.$emit("SHOW_TOAST", message, "red");
              close();
            });
        })
        .finally(() => {
          close();
        });
    },
  },
  watch: {
    plan_type() {
      // console.log(this.plan_type);
      this.getPlanShifts();
    },
  },
};
</script>
  